import { createContext, useCallback, useRef } from "react"
import styled from "styled-components"

interface FilesUploadContextValue {
  filesRef: React.RefObject<HTMLInputElement>
}

export const FilesUploadContext = createContext<FilesUploadContextValue>({} as FilesUploadContextValue)

const Input = styled.input`
  display: none;
`

interface FilesUploadProps extends React.InputHTMLAttributes<HTMLInputElement> {
  acceptFormats: string[]
  children: React.ReactNode
  onFilesChange: (files: File[]) => void
}

const FilesUpload = (props: FilesUploadProps) => {
  const { acceptFormats, children, onFilesChange, ...rest } = props

  const filesRef = useRef<HTMLInputElement>(null)

  const handleFilesChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!e.target.files) return

      const validFilesList = Array.from(e.target.files).filter((file) => acceptFormats.includes(file.type))

      onFilesChange(validFilesList)
    },
    [onFilesChange]
  )

  const contextValue = { filesRef }

  const acceptFormatsString = acceptFormats.join(",")

  return (
    <FilesUploadContext.Provider value={{ ...contextValue }}>
      <Input ref={filesRef} type="file" onChange={handleFilesChange} accept={acceptFormatsString} {...rest} />
      {children}
    </FilesUploadContext.Provider>
  )
}

export default FilesUpload
